import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSiteConfig } from "../../context/SiteConfigContext";
import { useCart } from "../../context/CartContext";

import {
  Swiper,
  SwiperSlide,
  Autoplay,
  Pagination,
} from "../homepage/Shared/CustomSwiper";
import { Heart } from "lucide-react";
import { showError } from "../../utils/toastUtils";
import Auth from "../../utils/AuthUtils";
import wishlistAPI from "../../api/wishlistApi";

function Card({ item }) {
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const { config } = useSiteConfig();

  const initialPrice =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.price ?? 0)
      : (item?.price ?? 0);

  const initialMrp =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.mrp ?? 0)
      : (item?.mrp ?? 0);

  const initialDiscount =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.discount ?? 0)
      : (item?.discount ?? 0);

  const initialStock =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.stock ?? 0)
      : (item?.stock ?? 0);

  const [image, setImage] = useState(item?.thumbnail);
  const [slug, setSlug] = useState(item?.slug);
  const [title, setTitle] = useState(item?.title);

  const [activePrice, setActivePrice] = useState(initialPrice);
  const [activeMrp, setActiveMrp] = useState(initialMrp);
  const [activeDiscount, setActiveDiscount] = useState(initialDiscount);
  const [activeStock, setActiveStock] = useState(initialStock);
  const [activeVariantId, setActiveVariantId] = useState(
    item?.productType === "Variant" && item?.variants?.length
      ? item?.variants[0]._id
      : null,
  );
  const [isWishlisted, setIsWishlisted] = useState(item.isWishlisted || false);

  const galleryImages = [item?.thumbnail, ...(item?.gallery || [])].filter(
    Boolean,
  );

  // Update price & image when variant changes
  useEffect(() => {
    if (item?.productType !== "Variant") return;
    const selected = item?.variants?.find((v) => v._id === activeVariantId);
    if (selected) {
      const newImg = selected.images?.[0] || item?.thumbnail;
      setImage(newImg);
      setActivePrice(selected.price);
      setActiveMrp(selected.mrp);
      setActiveDiscount(selected.discount);
      setActiveStock(selected.stock);
    }
  }, [activeVariantId, item]);

  const hasDiscount =
    activeDiscount !== null && activeDiscount > 0 && activeMrp > activePrice;

  const handleAddToCart = (e) => {
    const action = e.currentTarget.getAttribute("data-action");

    try {
      addToCart(item?._id, 1, activeVariantId || "");

      if (action === "buy-now") {
        navigate("/checkout");
      }
    } catch (err) {
      console.error("Add to cart error:", err);
    }
  };

  const handleWishlistToggle = async (e) => {
    e.preventDefault();

    const isLoggedIn = Auth.getToken();

    if (!isLoggedIn) {
      showError("Please log in to manage your wishlist");
      return;
    }

    try {
      const res = await wishlistAPI.addProduct({ productId: item?._id });
      if (res.code === 200) {
        setIsWishlisted((prev) => !prev);
      }
    } catch (error) {
      showError("Failed to update wishlist");
    }
  };

  const isOutOfStock = activeStock <= 0;

  return (
    <div className="product-card text-decoration-none">
      <div className="product-image-wrapper">
        <button
          type="button"
          className={`wishlist-btn ${isWishlisted ? "active" : ""}`}
          onClick={handleWishlistToggle}
          aria-label="Add to wishlist"
        >
          <Heart
            size={20}
            strokeWidth={isWishlisted ? 0 : 1.5}
            className="heart-icon"
          />
        </button>
        <Link to={`/shop/${slug}`} className="product-img-wrapper">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={10}
            slidesPerView={1}
            pagination={{ clickable: true }}
            autoplay={{ delay: 4000 }}
            className="product-swiper"
          >
            {galleryImages.map((img, index) => (
              <SwiperSlide key={index}>
                <img
                  src={img}
                  alt={title}
                  loading="lazy"
                  className="product-image"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </Link>

        {isOutOfStock && (
          <p className="text-danger fw-bold mt-1">Out of Stock</p>
        )}

        {!isOutOfStock && config?.productVisibility === "cart" && (
          <>
            {/* Click handle kar rahe hain */}
            <button
              className="add-to-cart-btn"
              data-id={item?._id}
              data-price={activePrice}
              data-variant={activeVariantId || ""}
              data-quantity={1}
              data-action="cart"
              data-bs-toggle="offcanvas"
              data-bs-target="#shoppingCartCanvas"
              onClick={handleAddToCart}
            >
              Add to Bag
            </button>
          </>
        )}
      </div>
      <div className="product-details text-center mt-md-3 mt-1">
        <h6 className="product-title">{title}</h6>

        <div className="card-bottom">
          <div className="d-flex">
            <p className="product-price mb-0">₹{activePrice}</p>
            {/* <p className="product-price-delete ms-2 mb-0">₹{activeMrp}</p> */}
            {Number(activeMrp) > Number(activePrice) && (
    <p className="product-price-delete ms-2 mb-0">
      ₹{activeMrp}
    </p>
  )}
          </div>
          <div className="discount-section">
            {hasDiscount && (
              <div className="discount-badge">
                {Math.round(activeDiscount)}% OFF
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Card;
